module.exports = __webpack_public_path__ + "media/images/country_flags/ps-e035a20265ff9142721e665a8504baee.png";